import
{
  ChangeDetectionStrategy, ChangeDetectorRef, Component, input,
  OnInit, AfterViewInit
} from '@angular/core';

import { ITask } from '../../../../models/client';
import { ClientService, FormTypeTableColumns, TableColumn } from '../../../../services/client-service';
import { DatatableComponent } from '../../../../utils/datatable-component/datatable-component';

@Component( {
  selector: 'app-tasks-component',
  imports: [
    DatatableComponent,
  ],
  templateUrl: './tasks-component.html',
  styleUrl: './tasks-component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
} )
export class TasksComponent implements OnInit, AfterViewInit {

  constructor(
    private _cdr: ChangeDetectorRef,
    private _clientService: ClientService,
  ) { }

  clientId = input.required<string>();
  clientsTasks: ITask[] | undefined;
  clientTasksColumns: TableColumn[] = [];

  ngOnInit(): void
  {   
    this.clientTasksColumns = FormTypeTableColumns['Tasks'].DefaultColumns.filter( c => !!c.field ) || [];
    this._cdr.detectChanges();
  }

  ngAfterViewInit(): void
  {
    this._clientService.getTasks( this.clientId() ).then(
      result =>
      {
        this.clientsTasks = result || [];
        this._cdr.detectChanges();
      }
    );
    this._cdr.detectChanges();
  }


}
